import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { formatApiErrorDetail } from "@/lib/api";

const inputCls =
  "w-full rounded-none border border-white/15 bg-zinc-900 px-4 py-3 font-body text-sm text-white placeholder-white/30 outline-none focus:border-neon-green focus:ring-1 focus:ring-neon-green";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && user) navigate("/admin");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-obsidian px-5" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-md border border-white/10 bg-surface p-8 sm:p-10">
        <Logo />
        <div className="mt-8 flex items-center gap-2">
          <ShieldCheck size={20} strokeWidth={2.5} className="text-neon-green" />
          <h1 className="font-heading text-3xl uppercase text-white">Admin Access</h1>
        </div>
        <p className="mt-2 font-body text-sm text-white/50">Sign in to view training registrations.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          {error && <div data-testid="login-error" className="border border-red-500/50 bg-red-500/10 px-4 py-3 font-body text-sm text-red-300">{error}</div>}
          <input required type="email" data-testid="login-email" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required type="password" data-testid="login-password" className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button disabled={loading} data-testid="login-submit" className="flex w-full items-center justify-center bg-neon-green py-4 font-heading text-lg uppercase tracking-widest text-black disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={22} /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
